import { engineComponent, NumberUtils } from "neo-common";
import { Communication } from "neo-games";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { CreateFrameTimer, FrameTimerEventEmitter, FrameTimerEvents } from "../../Utils/FrameTimer";
import { Paylines } from "../Paylines";
import { Symbols } from "../Symbols";
import { Machine } from "../Machine";
import { WinAnimator } from "../WinAnimator";
import { FreespinsController } from "./FreespinsController";
import { GameManager } from "../../Managers/GameManager";
import { PlayList } from "../../Components/Sounds/PlayList";
import { DataManager } from "../../Managers/DataManager";
import { BaseView } from "../Base/BaseView";
import { AmbientBackground } from "../../Utils/AmbientBackground";
import { WinAnimator2 } from "../../CustomComponents/WinAnimator2";
import { Tweens } from "../../Components/Effects/Tweens";
import { Languages } from "../../Utils/Languages";
import { PortraitLayout } from "../../CustomComponents/PortraitLayout";
import { TimelineElement } from "../../Components/Elements/Graphics/TimelineElement";
import { ModuleManager } from "../../Managers/ModuleManager";
import { ImageTextElement } from "../../Components/Elements/Texts/ImageTextElement";
import { SwitchElement } from "../../Components/Elements/Graphics/SwitchElement";
import { LayoutContainerElement } from "../../CustomComponents/LayoutContainerElement";

@engineComponent(ComponentTypes.DisplayObject)
export class FreespinsView extends LayoutContainerElement {
    public static ReelsFrame: SwitchElement;

    static TotalWin: TimelineElement;

    private _controller: FreespinsController;
    private _introDelay: FrameTimerEventEmitter;
    private _outroDelay: FrameTimerEventEmitter;
    private _paylines: Paylines;
    private _symbols: Symbols;
    private _machine: Machine;
    private _winAnimator: WinAnimator2;

    private _alphaArray: Array<any> = [];

    constructor() {
        super();
        this._introDelay = CreateFrameTimer("introDelay");
        this._introDelay.on(FrameTimerEvents.Complete, this.introFinished.bind(this));
        this._outroDelay = CreateFrameTimer("outroDelay");
        this._outroDelay.on(FrameTimerEvents.Complete, this.outroFinished.bind(this));
    }

    public create(node: Element): void {
        super.create(node);
        if (this.childs["Symbols"] != null) {
            this._symbols = this.childs["Symbols"];
            this.removeChild(this._symbols);
        }
        if (this.childs["Paylines"] != null) this._paylines = this.childs["Paylines"];
        if (this.childs["PaylinesTop"] != null) this._paylines.addTopContainer(this.childs["PaylinesTop"]);
        if (this.childs["Machine"] != null) this._machine = this.childs["Machine"];
        if (this.childs["WinAnimator"] != null) this._winAnimator = this.childs["WinAnimator"];
        if (this.childs["ReelsFrame"] != null) FreespinsView.ReelsFrame = this.childs["ReelsFrame"];
        FreespinsView.TotalWin = this.childs["TotalWin"];

        if (this.childs["Paylines"] != null) this._alphaArray.push(this.childs["Paylines"]);
        if (this.childs["Machine"] != null) this._alphaArray.push(this.childs["Machine"]);
        if (this.childs["NoWinContainer"] != null) this._alphaArray.push(this.childs["NoWinContainer"]);
        if (this.childs["WinContainer"] != null) this._alphaArray.push(this.childs["WinContainer"]);
        if (this.childs["WinAnimator"] != null) this._alphaArray.push(this.childs["WinAnimator"]);
        if (this.childs["ReelsFrame"] != null) this._alphaArray.push(this.childs["ReelsFrame"]);
        if (this.childs["Logo"] != null) this._alphaArray.push(this.childs["Logo"]);

        for (let i: number = 0; i < this._alphaArray.length; i++) {
            this._alphaArray[i].visible = false;
            this._alphaArray[i].alpha = 0;
        }

        if (this.childs["Portrait"] != null && this.childs["Portrait"] instanceof PortraitLayout) {
            (<PortraitLayout>this.childs["Portrait"]).init(this);
        }
    }

    public initReceived(controller: FreespinsController): void {
        this._controller = controller;

        if (this._symbols != null) {
            if (this._machine != null) {
                if (GameManager.freespinsResponse != null) {
                    if (
                        GameManager.freespinsResponse.initData != null &&
                        GameManager.freespinsResponse.initData.reels !== null
                    ) {
                        this._machine.on(Machine.ReelStopped, this.onReelStopped.bind(this));
                        this._machine.on(Machine.MachineStopped, this.machineStopped.bind(this));
                        this._machine.initialize(
                            this._symbols,
                            GameManager.freespinsResponse.initData.reels,
                            this.childs["Teasing"],
                            true,
                        );
                    }

                    if (this._winAnimator != null) {
                        this._winAnimator.on(WinAnimator.FinishWinCalculation, this.finishWinCalculation.bind(this));
                        this._winAnimator.on(WinAnimator.FinishWinAnimator, this.finishWinAnimator.bind(this));
                        this._winAnimator.on(
                            WinAnimator.FinishQuickWinCalculation,
                            this.finishQuickWinCalculation.bind(this),
                        );
                        this._winAnimator.on("ScatterPop", this.scatterPop.bind(this));
                        this._winAnimator.on("ScatterFinished", this.machineStoppedDelayed0.bind(this));
                        this._winAnimator.on("ExtraScatterFinished", this.machineStoppedDelayed.bind(this));
                        this._winAnimator.initialize(
                            this._symbols,
                            this._paylines,
                            this.childs["NoWinContainer"],
                            this.childs["WinContainer"],
                        );
                    }
                } else {
                    if (DEBUG) {
                        this.log("ERROR no freespin reponse");
                    }
                }
            } else {
                if (DEBUG) {
                    this.log("ERROR no machine");
                }
            }
        } else {
            if (DEBUG) {
                this.log("ERROR no symbols");
            }
        }
        this.visible = false;
    }

    public startReceived(): void {
        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.showSymbols(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.reset(true);
    }

    public spinReceived(): void {
        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._machine.spinStop(null, false, true);
    }

    public endReceived(): void {}

    public spin(): void {
        PlayList.loop("SND_FSLoop");
        if (BaseView.Transition != null && BaseView.Transition.getCurrentCase() !== "EMPTY") {
            BaseView.Transition.goToCase("END_RETRIGGER");
        }
        if (BaseView.Background != null && BaseView.Background.getCurrentCase() === "WIN_FS")
            BaseView.Background.goToCase("COLLECT_FS");
        if (FreespinsView.ReelsFrame != null && FreespinsView.ReelsFrame.getCurrentCase() === "CYCLE_WIN")
            FreespinsView.ReelsFrame.goToCase("TO_NORMAL");
        this._machine.spinStart(this._winAnimator.reset(true), true, this._winAnimator.currentSymbols);
    }

    public stop(): void {
        this._machine.spinStop(null, true);
    }

    public initIntro(): void {
        this.childs["ScarabValuesContainer"].addChild(BaseView.FeatureValues);

        if (BaseView.Background != null) BaseView.Background.goToCase("FS");
        if (BaseView.Logo != null) BaseView.Logo.goToCase("FS");
        for (let i: number = 0; i < this._alphaArray.length; i++) {
            this._alphaArray[i].visible = true;
            this._alphaArray[i].alpha = 1;
        }

        if (BaseView.FeatureValues != null) {
            BaseView.FeatureValues.goToCase("NORMAL");
            let defaultScatterWin: string = GameManager.freespinsResponse.customData["defaultScatterValue"];
            let scatterWin: string = GameManager.freespinsResponse.customData["scatterValue"];
            let difference: string = NumberUtils.subtract(
                GameManager.freespinsResponse.customData["scatterValue"],
                GameManager.freespinsResponse.customData["defaultScatterValue"],
            );
            defaultScatterWin = Languages.formatText(Languages.FormatMoney, defaultScatterWin + "");
            scatterWin = Languages.formatText(Languages.FormatMoney, scatterWin + "");
            difference = Languages.formatText(Languages.FormatMoney, difference + "");

            let amount: ImageTextElement = BaseView.FeatureValues.getChildElementByName("Amount") as ImageTextElement;
            amount.bitmapText.text = defaultScatterWin + "";
            amount.realign();

            let hasGoldenWin: boolean = false;
            for (let i: number = 0; i < GameManager.freespinsResponse.wins.length; i++) {
                if (
                    GameManager.freespinsResponse.wins[i].trigger === Communication.Game.WinTrigger.Scatter &&
                    GameManager.freespinsResponse.wins[i].payoutId === 10
                ) {
                    hasGoldenWin = true;
                }
            }

            if (parseFloat(difference) > 0 && !hasGoldenWin) {
                this._winAnimator.specialValue = difference;
                let plus: ImageTextElement = BaseView.FeatureValues.getChildElementByName("Plus") as ImageTextElement;
                plus.bitmapText.text = "+";
                plus.realign();
                let amount2: ImageTextElement = BaseView.FeatureValues.getChildElementByName(
                    "Amount2",
                ) as ImageTextElement;
                amount2.bitmapText.text = difference;
                amount2.realign();
            } else {
                let plus: ImageTextElement = BaseView.FeatureValues.getChildElementByName("Plus") as ImageTextElement;
                plus.bitmapText.text = "";
                plus.realign();
                let amount2: ImageTextElement = BaseView.FeatureValues.getChildElementByName(
                    "Amount2",
                ) as ImageTextElement;
                amount2.bitmapText.text = "";
                amount2.realign();
            }
        }

        AmbientBackground.changeAmbientBackground("fs", 0);
        this.extraScatterValue();
        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.showSymbols(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.showInitWins(GameManager.freespinsResponse.wins, GameManager.freespinsResponse.currentWin);
        this.visible = true;
        this.retrigger();
        if (this.isLastFreespin()) {
            PlayList.stop("SND_FSLoop");
            PlayList.loop("SND_FSEndWait");
            PlayList.play("SND_FSEnd");

            if (GameManager.freespinsResponse.totalWin > 0) {
                if (FreespinsView.TotalWin != null) {
                    this._winAnimator.reset(true);
                    this.addChild(FreespinsView.TotalWin);
                    FreespinsView.TotalWin.visible = true;
                    FreespinsView.TotalWin.play(GameManager.freespinsResponse.totalWin);
                }
            }
        } else {
            PlayList.loop("SND_FSLoop");
        }
    }

    public intro(long: boolean = false): void {
        this.visible = true;
        if (BaseView.Transition != null) {
            this.addChild(BaseView.Transition);
            BaseView.Transition.goToCase("END");
        }

        this.childs["ScarabValuesContainer"].addChild(BaseView.FeatureValues);

        if (BaseView.Background != null) BaseView.Background.goToCase("TO_FS");
        for (let i: number = 0; i < this._alphaArray.length; i++) {
            this._alphaArray[i].visible = true;
            Tweens.removeTweens(this._alphaArray[i]);
            Tweens.alphaTween(this._alphaArray[i], {
                alphas: [0, 1],
                tweenDuration: 15,
                tweenDelay: 0,
            });
        }
        this._introDelay.start(60);
    }

    public outro(): void {
        AmbientBackground.changeAmbientBackground("base", 90);
        this.visible = true;
        PlayList.stop("SND_FSLoop");
        PlayList.stop("SND_FSWait");
        PlayList.play("SND_FSTrans");
        if (FreespinsView.TotalWin != null) {
            this.addChild(FreespinsView.TotalWin);
            FreespinsView.TotalWin.goToOutro();
        }
        if (BaseView.Background != null) BaseView.Background.goToCase("TO_BASE");
        if (BaseView.Logo != null) BaseView.Logo.goToCase("TO_BASE");
        for (let i: number = 0; i < this._alphaArray.length; i++) {
            this._alphaArray[i].visible = true;
            Tweens.removeTweens(this._alphaArray[i]);
            Tweens.alphaTween(this._alphaArray[i], {
                alphas: [1, 0],
                tweenDuration: 15,
            });
        }
        this._outroDelay.start(15);
    }

    public disableLogo(): void {
        // if (this.childs['Logo'] != null) {
        //     this.removeChild(this.childs['Logo']);
        // }
    }

    public enable(): void {
        PlayList.play("SND_FSWin");
        PlayList.play("SND_FreeSpinVoice");
        PlayList.loop("SND_FSWait");
        PlayList.stop("SND_BaseLoop");
        if (BaseView.Transition != null) {
            BaseView.Transition.goToCase("START");
        }
    }

    private onReelStopped(): void {
        this._winAnimator.onReelStopped(GameManager.freespinsResponse.screen.reels, this._machine.actualReelStopped);
    }

    private scatterPop(): void {}

    private machineStopped(): void {
        if (GameManager.baseResponse.currentWin > 0 || ModuleManager.freespinsEnabled()) {
            if (BaseView.Background != null) BaseView.Background.goToCase("WIN_FS");
        } else {
            if (BaseView.Background != null && BaseView.Background.getCurrentCase() === "WIN")
                BaseView.Background.goToCase("COLLECT");
        }
        if (!this._winAnimator.checkFSScatters(this.isRetrigger())) {
            if (
                !this._winAnimator.checkExtraScatters(
                    GameManager.freespinsResponse.wins,
                    GameManager.freespinsResponse.currentWin,
                )
            ) {
                this.machineStoppedDelayed();
            } else {
                if (BaseView.Background != null) BaseView.Background.goToCase("WIN_FS");
                this._controller.scatterStart();
            }
        } else {
            if (BaseView.Background != null) BaseView.Background.goToCase("WIN_FS");
            this._controller.extraScatterStart();
        }
    }

    private machineStoppedDelayed0(): void {
        if (
            !this._winAnimator.checkExtraScatters(
                GameManager.freespinsResponse.wins,
                GameManager.freespinsResponse.currentWin,
            )
        ) {
            this.machineStoppedDelayed();
        } else {
            if (BaseView.Background != null) BaseView.Background.goToCase("WIN_FS");
            this._controller.scatterStart();
        }
    }

    private machineStoppedDelayed(): void {
        if (GameManager.freespinsResponse.currentWin > 0) {
            if (BaseView.Background != null) BaseView.Background.goToCase("WIN_FS");
        }
        this._controller.machineStopped();
        if (this._winAnimator.showWins(GameManager.freespinsResponse.wins, GameManager.freespinsResponse.currentWin)) {
            PlayList.stop("SND_FSLoop");
        }
        if (GameManager.freespinsResponse.currentWin === 0) {
            if (this.isLastFreespin()) {
                PlayList.stop("SND_FSLoop");
                PlayList.loop("SND_FSWait");
                PlayList.play("SND_FSEnd");
                if (GameManager.freespinsResponse.totalWin > 0) {
                    if (FreespinsView.TotalWin != null) {
                        this._winAnimator.reset(true);
                        this.addChild(FreespinsView.TotalWin);
                        FreespinsView.TotalWin.visible = true;
                        FreespinsView.TotalWin.play(GameManager.freespinsResponse.totalWin);
                    }
                }
            }
        }
    }

    private finishQuickWinCalculation(): void {
        this._controller.quickWinCalculationFinished();
    }

    private finishWinCalculation(): void {
        this._controller.winCalculationFinished();
    }

    private finishWinAnimator(): void {
        this._controller.allWinsFinished();

        if (this.isLastFreespin()) {
            PlayList.stop("SND_FSLoop");
            PlayList.loop("SND_FSWait");
            PlayList.play("SND_FSEnd");
            if (GameManager.freespinsResponse.totalWin > 0) {
                if (FreespinsView.TotalWin != null) {
                    this._winAnimator.reset(true);
                    this.addChild(FreespinsView.TotalWin);
                    FreespinsView.TotalWin.visible = true;
                    FreespinsView.TotalWin.play(GameManager.freespinsResponse.totalWin);
                }
            }
        } else {
            PlayList.loop("SND_FSLoop");
        }
        this.retrigger();
    }

    private introFinished(): void {
        for (let i: number = 0; i < this._alphaArray.length; i++) {
            this._alphaArray[i].visible = true;
            this._alphaArray[i].alpha = 1;
        }
        AmbientBackground.changeAmbientBackground("color-1", 0);
        PlayList.loop("SND_FSLoop");
        this._controller.introFinished();
    }

    private outroFinished(): void {
        for (let i: number = 0; i < this._alphaArray.length; i++) {
            this._alphaArray[i].visible = false;
            this._alphaArray[i].alpha = 0;
        }
        this._winAnimator.resetTimer();
        this._controller.outroFinished();
    }

    private retrigger(): void {
        if (!this.isLastFreespin()) {
            if (GameManager.freespinsResponse.wins != null && GameManager.freespinsResponse.wins.length > 0) {
                for (let i: number = 0; i < GameManager.freespinsResponse.wins.length; i++) {
                    if (
                        GameManager.freespinsResponse.wins[i].trigger === Communication.Game.WinTrigger.Scatter &&
                        GameManager.freespinsResponse.wins[i].type === Communication.Game.WinType.freeSpins
                    ) {
                        if (BaseView.Transition != null) {
                            this.addChild(BaseView.Transition);
                            BaseView.Transition.goToCase("START_RETRIGGER");
                            PlayList.play("SND_FSWin");
                            PlayList.play("SND_FreeSpinVoice");
                        }
                    }
                }
            }
        }
    }

    private isRetrigger(): boolean {
        if (!this.isLastFreespin()) {
            if (GameManager.freespinsResponse.wins != null && GameManager.freespinsResponse.wins.length > 0) {
                for (let i: number = 0; i < GameManager.freespinsResponse.wins.length; i++) {
                    if (
                        GameManager.freespinsResponse.wins[i].trigger === Communication.Game.WinTrigger.Scatter &&
                        GameManager.freespinsResponse.wins[i].type === Communication.Game.WinType.freeSpins
                    ) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    private isLastFreespin(): boolean {
        if (DataManager.GameLimit) {
            return true;
        }
        return (
            GameManager.freespinsResponse.freeSpins != null &&
            GameManager.freespinsResponse.freeSpins.remainingCount != null &&
            GameManager.freespinsResponse.freeSpins.remainingCount === 0
        );
    }

    private extraScatterValue(): void {
        // if(GameManager.freespinsResponse != null && GameManager.freespinsResponse.freeSpins != null && GameManager.freespinsResponse.freeSpins.customData['newValue'] != null) {
        //     let newValue: string = Languages.formatText(Languages.FormatMoney, GameManager.freespinsResponse.freeSpins.customData['newValue'].toString());
        //     DataManager.updateGameDataFromModule('EXTRA_SCATTER_VALUE_NEW', newValue);
        //     DataManager.updateDataElement('EXTRA_SCATTER_VALUE_NEW', newValue);
        // }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Freespins/FreespinsView.ts
 **/